import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import {
  MatTableDataSource,
  MatSelect,
  MatDialog
} from "@angular/material";

import { ICourse } from "src/app/interfaces/course";
import { IBranch } from "src/app/interfaces/branch";
import { TranslateService } from "@ngstack/translate";
import { ICompany } from "src/app/interfaces/company";
import { ICalendar } from "src/app/interfaces/calendar";
import { ITermInfo } from "src/app/interfaces/term-info";
import { ICourseType } from "src/app/interfaces/course-type";
import { BIDService } from "src/app/services/common/bid.service";
import { CIDService } from "src/app/services/common/cid.service";
import { ICoursePattern } from "src/app/interfaces/coursePattern";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { SettingService } from "src/app/services/http/business/setting/setting.service";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
//import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
import * as momentJalali from "jalali-moment";
//import * as moment from 'moment';
import { ActivatedRoute } from "@angular/router";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { ParrentTermService } from "src/app/services/http/business/parrent-term/parrent-term-service.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { environment } from "src/environments/environment";
import { StudentListComponent } from "./student-list/student-list.component";
import { RoomService } from "src/app/services/http/business/room/room.service";

@Component({
  selector: 'app-student-sessions-checkout',
  templateUrl: './student-sessions-checkout.component.html',
  styleUrls: ['./student-sessions-checkout.component.css']
})
export class StudentSessionsCheckoutComponent implements OnInit {
  times = [];
  param: any;
  convertTZ: any;
  fullTime: any;
  formData: any;
  roomList: any;
  errObject: any;
  isOwner: boolean;
  TermInfoId: number;
  branchList: IBranch;
  yearList: ICalendar;
  errors = new Array();
  companyList: ICompany;
  expand: boolean = true;
  scheduleForm: FormGroup;
  termInfoForm: FormGroup;
  sessionForm: FormGroup;
  sessionDuration: number;
  timeLineEndPoint: number;
  data: any;
  hideTerms: boolean = true;
  timeLineStartPoint: number;
  addCourseEntryData: ICourse;
  courseTypeList: ICourseType;
  hideScheduleTime: boolean = true;
  coursePatternList: ICoursePattern;
  skip: number = 0;
  selectAll: boolean;
  termList: ITermInfo[];
  sessionList = [];
  allSession = [];
  parrentTermList: IParentTerm[];

  currentModel: any;
  //checkAll: boolean;

  route_companyEncryptId: any;
  route_branchEncryptId: any;
  route_termInfoId: any;

  CompanyEncrypt: string;
  BranchEncrypt: string;
  TermInfo: number;

  dataSource = new MatTableDataSource<ITermInfo>();

  form: FormGroup;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private bidService: BIDService,
    private cidService: CIDService,
    private roomService: RoomService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private courseService: CourseService,
    private holdingService: HoldingService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private settingService: SettingService,
    private calendarService: CalendarService,
    private courseTypeService: CourseTypeService,
    private parrentTermService: ParrentTermService,
    private coursePatternService: CoursePatternService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    this.createSessionForm();
    this.getCompanyList();

    this.route.params.subscribe(res => {
      this.CompanyEncrypt = res.company.replace(/-/g, '=');
      this.BranchEncrypt = res.branch.replace(/-/g, '=');
      this.TermInfo = res.terminfo;
      this.termList = [];
      this.sessionList = [];
      this.allSession = [];
      this.times = [];
      this.cidService.setCID(this.CompanyEncrypt);
      this.timeLine();
      this.branchService.list(true).subscribe(response => {
        this.branchList = response.DataList;
        if (this.isOwner)
          this.bidService.setBID(this.BranchEncrypt);
        this.getRoomsList();
      });

    });
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (!res.IsOwner) {
        this.timeLine();
        this.getParrentTermList();
        this.form.controls['CompanyEncryptId'].patchValue(this.cidService.getCID());
        this.form.controls['BranchEncryptId'].patchValue(this.bidService.getBID());
      }
    });
  }
  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null, Validators.required],
      BranchEncryptId: [null, Validators.required],
      ParentTermId: [null, Validators.required],
      DateNow: [new Date(), Validators.required]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  loginToVirtualClass(url: string) {
    const win = window.open(
      environment.AdobeConnect + "/api/xml?action=login&login=" + JSON.parse(window.localStorage.getItem('userInfo')).NationalCode + "&password=" + JSON.parse(window.localStorage.getItem('userInfo')).NationalCode,
      'Adobe Connect');
    setTimeout(function () {
      win.location.href = url;
    }, 1)
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.timeLine();
    this.loadBranchList();
    this.loadCoursTypeList();
    this.loadCoursePattern();
    this.getParrentTermList();
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
    this.getRoomsList();
  }

  getParrentTermList() {
    this.parrentTermService.list(0, 0).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  createSessionForm() {
    this.sessionForm = this.fb.group({
      sessions: this.fb.array([])
    });
  }

  loadBranchList() {
    this.branchService.list(true).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursTypeList() {
    this.courseTypeService.list().subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  nextDay() {
    let date: Date = new Date(this.form.controls["DateNow"].value);
    date.setDate(date.getDate() + 1);
    this.form.controls["DateNow"].setValue(date);
    this.submit(this.form.value);
  }

  previousDay() {
    let date: Date = new Date(this.form.controls["DateNow"].value);
    date.setDate(date.getDate() - 1);
    this.form.controls["DateNow"].setValue(date);
    this.submit(this.form.value);
  }

  validatorSessionDate(termId: any, date: any): boolean {
    let temp = true;
    this.termList.forEach(element => {
      if (element.Id == termId) {
        if (date >= element.StartDate && date <= element.EndDate) {
          temp = true;
        } else {
          temp = false;
        }
      }
    });
    return temp;

  }

  //  student list
  showStudents(room: any, teacher: any): void {

    let command: any = {
      CourseId: teacher.CourseId,
      AllSessionId: teacher.AllSessionId,
      CourseStatusId: teacher.CourseStatusId,
      RoomId: room.Id,
      TeacherUserEncryptId: teacher.TeacherUserEncryptId,
      FullName: teacher.FullName,
      LevelName: teacher.LevelName,
      TimeStart: teacher.TimeStart,
      TimeEnd: teacher.TimeEnd,
    };
    this.dialog.open(StudentListComponent, {
      data: command,
      disableClose: true,
      width: "800px",
    })
      .afterClosed()
      .subscribe(() => { });
  }

  loadCoursePattern() {

    this.coursePatternService.getList().subscribe(
      res => {
        this.coursePatternList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  calculateDuration(e: MatSelect) {
    this.coursePatternService.getById(e.value).subscribe(res => {
      this.sessionDuration = res.SessionDuration;
    });
  }

  getRoomsList() {
    this.roomService.list(0, 0).subscribe(
      res => {
        this.roomList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  checkFullTime(time: Date, _index, room, session): any {
    var res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time < element.TimeEnd) {
            this.skip = this.calcWidth(element.TimeStart, element.TimeEnd);
            res = true;
            session.teacher = element;
            // this.arry.push(element);
            return res;
          }
        });
      }
    }
    if (this.skip > 0) {
      this.skip = this.skip - 1;
    }

    return res;
  }

  checkStartTime(time, _index, room): any {
    var res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time == element.TimeStart) {
            res = true;
            return res;
          }
        });
      }
    }
    return res;
  }

  test(time, _index, room): any {
    let res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time <= element.TimeEnd) {
            res = true;
            return;
          }
        });
      }
    }
    return res;
  }

  loadBranchAndTerms(e: any) {

    this.termList = [];
    this.sessionList = [];
    this.allSession = [];
    this.times = [];
    this.cidService.setCID(e.value);
    this.timeLine();
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
    });
    this.getParrentTermList();
  }

  submit(data: any) {
    if (this.isOwner) {
      this.cidService.setCID(this.form.controls['CompanyEncryptId'].value);
      this.bidService.setBID(this.form.controls['BranchEncryptId'].value);
    }
    this.getRoomsList();
    this.hideScheduleTime = true;
    if (typeof (data.DateNow) !== 'string') {
      data.DateNow = momentJalali
        .from(data.DateNow, "en")
        .utc(true)
        .format(environment.dateFormat);
      // data.DateNow=data.DateNow.slice(0,16);

    }
    this.currentModel = {
      TermInfoId: data.TermInfoId,
      BranchEncryptId: data.BranchEncryptId,
      DateNow: data.DateNow
    }
    this.courseService
      .getAttendance(data.ParentTermId, data.BranchEncryptId, data.DateNow)
      .subscribe(res => {
        this.fullTime = res;
        this.fullTime.forEach(element => {
          element.RoomTimeList.forEach(item => {
            if (item.AllSessionStatusId == 91) {
              item["isSelectItem"] = true;
            } else if (item.AllSessionStatusId == 92) {
              item["isSelectItem"] = false;
            } else {
              item["isSelectItem"] = null;
            }
            this.allSession.push(item);
          });
        });
        if (this.allSession.length != 0) {
          this.selectAll = null;
        }


        this.hideScheduleTime = false;
      });
    this.sessionList = [];
    this.allSession = [];


  }

  timeLine() {
    this.settingService.getTimeLine().subscribe(
      res => {
        this.timeLineStartPoint = parseInt(res.CourseTimeStart.slice(0, 5));
        this.timeLineEndPoint = parseInt(res.CourseTimeEnd.slice(0, 5));
        var quarterHours = ["00:00", "15:00", "30:00", "45:00"];
        for (var i = this.timeLineStartPoint; i < this.timeLineEndPoint; i++) {
          for (let j = 0; j < 4; j++) {
            if (i < 10) {
              this.times.push("0" + i + ":" + quarterHours[j]);
            } else {
              this.times.push(i + ":" + quarterHours[j]);
            }
          }
        }
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }


  calcWidth(timeStart, timeEnd) {
    var timeS = Number(timeStart.split(':')[0]) * 60 * 60 * 1000 + Number(timeStart.split(':')[1]) * 60 * 1000;
    var timeE = Number(timeEnd.split(':')[0]) * 60 * 60 * 1000 + Number(timeEnd.split(':')[1]) * 60 * 1000;
    return Math.ceil(((timeE - timeS) / (1000 * 60 * 15)));
  }

  // courseSessionsCheckout() {
  //   //this.router.navigate(["/management/institute/courseSessionsCheckout"]);
  // }



}
